module.exports = __webpack_public_path__ + "static/media/NEW PLAYBOOK FOR RESTAURANT - EBOOK.8fabf626.pdf";